export default {
    mobile: 480, // 480px
    tablet: 768, // 768px
    desktop: 1024, // 1024px
    large: 1240, // 1240px Includes extra 40px for Gutters.
};
